import React from 'react';
import { OverlaySpinner, Sidebar } from '@insurancemenu/imenu-components-lib';
import Notes from 'components/common/group/sidebar/Notes';
import { useRootStore } from 'store/rootStore';
import ContactInfo from 'components/common/group/sidebar/ContactInfo';
import { observer } from 'mobx-react-lite';
import AdditionalAccess from 'components/common/group/sidebar/AdditionalAccess';
import { useParams } from 'react-router-dom';
import Attachments from 'components/common/group/sidebar/Attachments';
import AssignedInfo from './AssignedInfo';
import AgentOfRecord from './AgentOfRecord';
import { createStyles } from './styles';
import InviteAdmin from './InviteAdmin';

const GroupInfoSidebar: React.FC = observer(() => {
  const { groupId } = useParams<{ groupId: string }>();

  const {
    domainStoreV2: { groupInitiationRedirect },
    groupInfoController: { pageLoading },
  } = useRootStore();

  const classes = createStyles();
  return (
    <Sidebar className={classes.sidebar}>
      <ContactInfo />
      <InviteAdmin />
      {!groupInitiationRedirect && <AgentOfRecord />}
      <AssignedInfo />
      <AdditionalAccess groupId={groupId} editableType="ICON" />
      <Notes />
      <Attachments />
      <OverlaySpinner display={pageLoading} />
    </Sidebar>
  );
});

export default GroupInfoSidebar;
